import React, { useEffect, useState, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { baseURL, sistemaURL } from '../url.js';
import '../../css/Components/Banners/Banner.css';
//import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
//SwiperCore.use([Navigation, Pagination, Autoplay]); 

export default function Banners() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef(null);

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [images]);

    const cargarBanners = () => { 
        fetch(`${sistemaURL}/web/getBanners`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                /*const bannerImages = data.banner.map(banner => banner.imagen);
                setImages(bannerImages);*/
                setImages(data)
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)

            });
    };

    return (
        <div className='BannerContain'>

            {loading ? (
                <div className='loadingBanner'>

                </div>

            ) : (
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    effect={'coverflow'}
                    grabCursor={true}
                    loop={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                    autoplay={{ delay: 3000 }}
                    pagination={{ clickable: true }}
                    onSwiper={(swiper) => {
                        //console.log(swiper);
                        swiperRef.current = swiper;
                    }}
                    id='swiper_container'
                >
                    {images.map((image, index) => (
                        <SwiperSlide id='SwiperSlide-scroll' key={index}>
                            <img src={`${sistemaURL}${image}`} alt={`imagen-${index}`} />
                        </SwiperSlide>
                    ))}
                </Swiper>

                // <Swiper
                //     modules={[Navigation, Pagination, Autoplay]}
                //     spaceBetween={50}
                //     slidesPerView={3}
                //     navigation
                //     pagination={{ clickable: true }}
                //     scrollbar={{ draggable: true }}
                // >

                //     {images.map((image, index) => (
                //         <SwiperSlide id='SwiperSlide-scroll' key={index}>
                //             <img src={`${sistemaURL}${image}`} alt={`imagen-${index}`} />
                //         </SwiperSlide>
                //     ))}
                // </Swiper>
            )}

        </div>
    );
}
